export const isMacintosh = navigator.platform.includes('MacIntel');
export const altLabel = isMacintosh ? '⌥' : 'Alt';
export const surveyUrl = 'https://forms.gle/o2CV4tL7R29Np1bk6';
